import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.336 5.523v6.835c0 .777.306 1.522.855 2.071l8.047 8.047a2.925 2.925 0 0 0 4.137 0l6.104-6.104a2.925 2.925 0 0 0 0-4.137l-8.047-8.047a2.93 2.93 0 0 0-2.071-.855h-6.83a2.19 2.19 0 0 0-2.195 2.19m5.12 4.39c-.809 0-1.462-.655-1.462-1.464 0-.81.653-1.463 1.463-1.463.809 0 1.463.654 1.463 1.463 0 .81-.654 1.463-1.463 1.463"
    }, null, -1)
  ]))]))
}
export default { render: render }